import {
  createContext,
  type FC,
  type ComponentType,
  type PropsWithChildren
} from 'react';
import {
  createPortal
} from 'react-dom';
import {
  useDispatch
} from 'react-redux';
import {
  useCheckAppVersionSelector,
  setOpenOutdatedAppVersionModal,
  selectOpenOutdatedAppVersionModal
} from '../model';
import {
  OutdatedAppVersionModal
} from './outdated-app-version-modal.component';

export const OutdatedAppVersionModalContext = createContext<null>(null);

export const WithOutdatedAppVersionModalProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const dispatch = useDispatch();
  const modalRoot = document.querySelector('#modal-root');
  const openOutdatedAppVersionModal = useCheckAppVersionSelector(selectOpenOutdatedAppVersionModal);

  const handleUpdateOutdatedAppVersion = (): void => {
    dispatch(setOpenOutdatedAppVersionModal(false));
    window.location.reload();
  };

  return (
    <OutdatedAppVersionModalContext.Provider value={null}>
      {children}
      {(openOutdatedAppVersionModal && modalRoot) && createPortal((
        <OutdatedAppVersionModal
          open={openOutdatedAppVersionModal}
          onUpdate={handleUpdateOutdatedAppVersion}
        />
      ), modalRoot)}
    </OutdatedAppVersionModalContext.Provider>
  );
};

export const withOutdatedAppVersionModal = <P extends object>
  (WrappedComponent: ComponentType<P>) => (props: P) => (
    <WithOutdatedAppVersionModalProvider>
      <WrappedComponent {...props} />
    </WithOutdatedAppVersionModalProvider>
  );